export default "__VITE_ASSET__DCRdcueh__"